import { RDFSerializer } from '@openhps/rdf';
import { EventEmitter } from 'events';
import WebSocket from 'isomorphic-ws';
import { ActivityAdd } from '../models';
/**
 * Solid Dataset subscription
 */
export class DatasetSubscription extends EventEmitter {
    constructor() {
        super();
    }
    /**
     * Create a new dataset subscription
     * @param {string} websocketUri  Websocket URI
     * @param {IriString} [channelType]  Channel type
     * @returns {Promise<DatasetSubscription>}      Dataset subscription
     */
    static create(websocketUri, channelType) {
        return new Promise((resolve) => {
            const subscription = new DatasetSubscription();
            subscription._ws = new WebSocket(websocketUri, ['solid-0.1']);
            subscription._ws.onopen = () => {
                resolve(subscription);
            };
            if (channelType) {
                subscription._ws.onmessage = (msg) => {
                    subscription.emit('message', msg.data);
                    try {
                        // Deserialize message (activity stream)
                        RDFSerializer.deserializeFromJSONLD(undefined, JSON.parse(msg.data))
                            .then((activity) => {
                            if (activity) {
                                subscription.emit('activity', activity);
                            }
                            else {
                                subscription.emit('error', new Error('Failed to deserialize activity stream'));
                            }
                        })
                            .catch((error) => {
                            subscription.emit('error', error);
                        });
                    }
                    catch (error) {
                        subscription.emit('error', error);
                    }
                };
            }
            else {
                // Legacy
                subscription._ws.onmessage = (msg) => {
                    if (msg.data && msg.data.slice(0, 3) === 'pub') {
                        const activity = new ActivityAdd();
                        activity.object = msg.data.substring(3);
                        subscription.emit('activity', activity);
                    }
                };
            }
            subscription._ws.onerror = (e) => {
                subscription.emit('error', e);
            };
        });
    }
    /**
     * Subscribe to a dataset
     * @param {string} uri  Dataset URI
     */
    subscribe(uri) {
        this._ws.send(`sub ${uri}`);
    }
    /**
     * Close the subscription
     */
    close() {
        if (this._ws) {
            this._ws.close();
        }
    }
    on(event, listener) {
        return super.on(event, listener);
    }
}
//# sourceMappingURL=DatasetSubscription.js.map